__turbopack_context__.v({
  "contentWrap": "UxehvG_contentWrap",
  "root": "UxehvG_root",
  "sideNavWrap": "UxehvG_sideNavWrap",
});
